import * as querystring from 'querystring'

export function parse(urlOrQs) {
    let qs = urlOrQs;
    const i = qs.indexOf('?');
    if (i >= 0) {
        qs = qs.substr(i + 1);
    }
    return querystring.decode(qs);
}

function getParts(url) {
    const parts = {};
    if(typeof url === 'string') {
        parts.path = url;

        const qIndex = url.indexOf('?');
        const hIndex = url.indexOf('#');
        if(qIndex >= 0 || hIndex >= 0){
            const pEndIndex = qIndex >= 0 ? qIndex : hIndex;
            parts.path = url.substr(0, pEndIndex);
            if(qIndex >= 0){
                const qEndIndex = (hIndex >= 0 ? hIndex - 1: url.length) - qIndex;
                parts.query = url.substr(qIndex + 1, qEndIndex);
            }
            if(hIndex >= 0){
                parts.hash = url.substr(hIndex + 1);
            }
        }
    }
    return parts;
}

function joinParts(parts) {
    let url = parts.path || '';
    if (typeof parts.query === 'string' && parts.query.length > 0) {
        url += '?' + parts.query
    }
    if (typeof parts.hash === 'string' && parts.hash.length > 0) {
        url += '#' + parts.hash;
    }
    return url;
}

export function modify(url, cb) {
    if (typeof cb !== 'function') return;
    const parts = getParts(url);
    let qs = parse(parts.query || '');
    const ret = cb(qs);
    if (typeof ret === 'object') {
        qs = ret;
    }
    parts.query = stringify(qs);
    return joinParts(parts);
}

export function stringify(){
    return querystring.encode.apply(this, arguments);
}

export default {
    parse: parse,
    stringify: stringify,
    modify: modify
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/querystring.js